import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";
import { headerPost } from "@/config"

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function login(username, phonenumber, password) {
	return client.post('login', qs.stringify({ username, phonenumber, password }), headerPost);
}

function switchAccount(params) {
	return client.post("member/account/login", qs.stringify(params), {
		header: {
			"Content-Type": "multipart/form-data"
		}
	});
}

export default {
	login,
	switchAccount
};